import { render, staticRenderFns } from "./formDesconto.vue?vue&type=template&id=292b05d6"
import script from "./formDesconto.vue?vue&type=script&lang=js"
export * from "./formDesconto.vue?vue&type=script&lang=js"
import style0 from "./formDesconto.vue?vue&type=style&index=0&id=292b05d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports